import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of ProductTypess.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListProductTypesPage - Lazy-loaded ListProductTypesPage component.
 */
const ListProductTypePage = Loadable(
  lazy(() => import("./ListProductTypePage"))
);

/**
 * Lazy-loaded component for rendering the add ProductTypes page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddProductTypesPage - Lazy-loaded AddProductTypesPage component.
 */
const AddProductTypePage = Loadable(lazy(() => import("./AddProductTypePage")));

/**
 * Lazy-loaded component for rendering the View ProductTypes page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewProductTypesPage - Lazy-loaded ViewProductTypesPage component.
 */
const ViewProductTypePage = Loadable(
  lazy(() => import("./ViewProductTypePage"))
);

/**
 * Lazy-loaded component for rendering the View ProductTypes page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewProductTypesPage - Lazy-loaded ViewProductTypesPage component.
 */
const EditProductTypePage = Loadable(
  lazy(() => import("./EditProductTypePage"))
);

/**
 * Array containing route definitions for the ProductTypes-related pages.
 * @constant {Object[]} ProductTypeRoutes - Array of ProductTypes route objects.
 * @property {string} ProductTypeRoutes[].path - The path of the ProductTypes route.
 * @property {React.ReactElement} ProductTypeRoutes[].element - The React element to be rendered for the ProductTypes route.
 */
const ProductTypeRoutes = [
  {
    path: "list",
    element: <ListProductTypePage />,
  },
  {
    path: "add",
    element: <AddProductTypePage />,
  },
  {
    path: "view/:product_type_id",
    element: <ViewProductTypePage />,
  },
  {
    path: "edit/:product_type_id",
    element: <EditProductTypePage />,
  },
];

export default ProductTypeRoutes;
